import React from "react"
import types from "prop-types"
import { DndProvider } from "react-dnd"
import { HTML5Backend } from "react-dnd-html5-backend"
import { useSelector } from "react-redux"
import { LargeWrap } from "shared/wraps"
import { DataCollectorContainer, DataCollectorStep } from "components/shared/dataCollector"
import { selectedCategorySlug, selectedTaskFormSlug } from "reduxSlices/taskReportBuilderSlice"
import NameInput from "./NameInput"
import SharedInput from "./SharedInput"
import SolutionSelector from "./SolutionSelector"
import TaskFormSelector from "./TaskFormSelector"
import ColumnSelector from "./ColumnSelector"
import TaskReportBuilderActions from "./TaskReportBuilderActions"

const renderHeaderContent = (reportId) => {
  const title = reportId ? "Edit" : "Which task form would you like to export?"
  return (<span className="font-medium text-xl">{title}</span>)
}

const TaskReportBuilder = ({ reportId = null }) => {
  const categorySlug = useSelector(selectedCategorySlug)
  const taskFormSlug = useSelector(selectedTaskFormSlug)

  return (
    <DndProvider backend={HTML5Backend}>
      <LargeWrap>
        <DataCollectorContainer renderHeaderContent={() => renderHeaderContent(reportId)}>
          <DataCollectorStep stepNumber={1}>
            <NameInput />
            <SharedInput />
          </DataCollectorStep>
          <DataCollectorStep stepNumber={2} heading="Solution">
            <SolutionSelector />
          </DataCollectorStep>
          {
            categorySlug && (
              <DataCollectorStep stepNumber={3} heading="Task Form">
                <TaskFormSelector />
              </DataCollectorStep>
            )
          }
          {
            categorySlug && taskFormSlug && (
              <DataCollectorStep stepNumber={4} heading="Columns">
                <ColumnSelector />
              </DataCollectorStep>
            )
          }
          <TaskReportBuilderActions reportId={reportId} />
        </DataCollectorContainer>
      </LargeWrap>
    </DndProvider>
  )
}

TaskReportBuilder.propTypes = {
  reportId: types.number,
}

export default TaskReportBuilder
